import React, { FunctionComponent, ReactNode } from 'react';
import styles from './TeamLayout.scss';

type TeamLayoutProps = {
  slots: {
    featureImage: ReactNode;
    membersMini: ReactNode;
    title: ReactNode;
    totals: ReactNode;
    callsToAction: ReactNode;
    titleSupplementary: ReactNode;
    causeMini: ReactNode;
    story: ReactNode;
    main: ReactNode;
    aside: ReactNode;
    aboutTeam: ReactNode;
    contentFooterPrimary: ReactNode;
    contentFooterSecondary: ReactNode;
  };
};

const TeamLayout: FunctionComponent<TeamLayoutProps> = ({ slots }) => (
  <>
    <div data-qa="app" className={styles.container}>
      <div className={styles.grid}>
        <section className={styles.featureImage}>{slots.featureImage}</section>

        <section className={styles.membersMini}>{slots.membersMini}</section>

        <h1 className={styles.title} data-qa="page-title">
          {slots.title}
        </h1>

        <section
          className={styles.titleSupplementary}
          data-qa="charity-summary"
        >
          {slots.titleSupplementary}
        </section>

        <section className={styles.totalsWrapper}>
          <figure className={styles.totals}>{slots.totals}</figure>

          {slots.callsToAction}
        </section>

        <div className={styles.aboutOwnerMini}>{slots.causeMini}</div>

        <div className={styles.story}>{slots.story}</div>

        <main className={styles.main}>{slots.main}</main>

        <aside className={styles.aside}>{slots.aside}</aside>

        <aside className={styles.teamsAbout}>{slots.aboutTeam}</aside>
      </div>
    </div>
    <div className={styles.bottomWrapper}>
      <div className={styles.bottom}>{slots.contentFooterPrimary}</div>
    </div>
    <div className={styles.bottomWrapper}>
      <div className={styles.bottom}>{slots.contentFooterSecondary}</div>
    </div>
  </>
);

export default TeamLayout;
